webpackJsonp([46],{

/***/ 10:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return floatMenu; });
/**
 * Created by lycheng on 2017/12/4.
 * 浮动导航，默认是右边悬浮，需要改变位置可使用
 * floatMenu.config.position重新赋值
 */

// 右边导航
var floatMenu = {
  config: {
    top: 90,
    $container: $('html,body'),
    checkedClass: 'nav-checked',
    position: {
      top: {
        position: 'absolute',
        top: '600px',
        bottom: 'auto'
      },
      middle: {
        position: 'fixed',
        top: '150px',
        bottom: 'auto'
      },
      bottom: {
        // position: 'fixed',
        // top: '500px',
        // bottom: '0'
      },
      minTop: {
        position: 'fixed',
        top: '550px',
        bottom: 'auto'
      },
      minBottom: {
        position: 'fixed',
        top: '150px',
        bottom: 'auto'
      }
    }
  },
  init: function init() {
    floatMenu.bindEvent();
    floatMenu.methods.rePosition();
  },
  bindEvent: function bindEvent() {
    $('.js-service-nav-fall li').off('click').on('click', function () {
      var target = $(this).attr('target');
      floatMenu.methods.toPosition(target);
    });
    window.onscroll = function () {
      floatMenu.methods.rePosition();
    };
    window.onscroll();
  },
  methods: {
    toPosition: function toPosition(target) {
      var top = $('.' + target).offset().top - floatMenu.config.top;
      floatMenu.config.$container.animate({ scrollTop: Math.floor(top) }, 500);
    },
    rePosition: function rePosition() {
      var tops = [];
      var top = $('body').scrollTop() || $('html').scrollTop();
      var $navCon = $('.js-service-nav-fall');
      var $navItem = $('.js-service-nav-fall li');
      var targets = [];
      var i = 0;
      var position = floatMenu.config.position;
      $navItem.each(function () {
        targets.push($(this).attr('target'));
      });

      for (i = 0; i < targets.length; i++) {
        tops.push(Math.floor($('.' + targets[i]).offset().top) - floatMenu.config.top);
      }
      tops.push(tops[i - 1] + $('.' + targets[i - 1]).height());

      for (i = 0; i < targets.length; i++) {
        if (top >= tops[i]) {
          $navItem.removeClass(floatMenu.config.checkedClass);
          $navItem.filter('[target="' + targets[i] + '"]').addClass(floatMenu.config.checkedClass);
        }
      }

      if (top >= tops[0]) {
        if (top + $navCon.height() + floatMenu.config.top > tops[tops.length - 1]) {
          $navCon.css(position.bottom);
        } else {
          $navCon.css(position.middle);
        }
      } else {
        $navCon.css(position.top);
      }
    }

  }
};


/***/ }),

/***/ 13:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return serviceQA; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return serviceTopbar; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_config__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_js_libs_utils_suspension__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_js_libs_utils_float_menu__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_js_libs_utils__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_js_api_user__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_js_libs_utils_login__ = __webpack_require__(8);
/**
 * Created by lycheng on 2017/12/4.
 * 所有service都需要引入
 */








function serviceQA() {
  var $serviceQA = $('.service-item-qa');
  // 问答题超过两组时隐藏超出部分
  if ($serviceQA.length) {
    var oLi = $serviceQA.find('li');
    if (oLi.length <= 4) {
      $('.service-qa-more').hide();
    }
    for (var i = 0; i < oLi.length; i++) {
      if (i >= 4) {
        oLi.eq(i).hide();
      }
    }
  }
  // 点击查看更多显示超出部分
  $('.service-qa-more').click(function () {
    var oLi = $serviceQA.find('li');
    oLi.show();
    $(this).hide();
  });
}

function serviceTopbar() {
  var $serviceTopbar = $('.service-topbar');
  if ($serviceTopbar.length) {
    $(window).scroll(function () {
      var windowPosition = $(window).scrollTop();
      if (windowPosition >= 450) {
        $('.service-topbar').show();
      } else {
        $('.service-topbar').hide();
      }
    });
  }
}

// 滑动到产品价格
function scrollToPrice() {
  $('html,body').animate({
    scrollTop: $('.service-item-price').offset().top - 100
  }, 1e3);
}

function bindEvent() {
  // banner下立即申请
  $('.banner-to-service-manage, .banner-to-service-manage').click(function () {
    var serviceKey = this.dataset.serviceKey;
    if (serviceKey === 'face' || serviceKey === 'isv' || serviceKey === 'xpush') {
      serviceKey = 'base';
    }
    Object(__WEBPACK_IMPORTED_MODULE_3_js_libs_utils__["h" /* toUrl */])(__WEBPACK_IMPORTED_MODULE_0_config__["a" /* config */].CONSOLE + 'services/' + serviceKey, '_blank');
  });
  $('.to-price').click(function () {
    scrollToPrice();
  });
  // 滑动到产品价格
  var hash = location.hash;
  if (hash === '#price') {
    scrollToPrice();
  }
  if (Object(__WEBPACK_IMPORTED_MODULE_3_js_libs_utils__["c" /* getQueryString */])('target') === 'price') {
    scrollToPrice();
  }
}
bindEvent();
Object(__WEBPACK_IMPORTED_MODULE_1_js_libs_utils_suspension__["a" /* suspension */])();
if ($('.js-service-nav-fall').length) {
  __WEBPACK_IMPORTED_MODULE_2_js_libs_utils_float_menu__["a" /* floatMenu */].init();
}



/***/ }),

/***/ 14:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export getServiceOpenApps */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return getApps; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return getMobileappSdkList; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "n", function() { return openService; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "m", function() { return openOcrService; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "l", function() { return openNewFrameService; });
/* unused harmony export webTTS */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "k", function() { return mtranslate; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "j", function() { return lexicalAnalysist; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return getOtsResult; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return getItsResult; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "o", function() { return productKesa; });
/* unused harmony export getOnlineAudioSrc */
/* unused harmony export getVoiceAudioSrc */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "i", function() { return getValidate; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return getIatSign; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return getIatLanguage; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "h", function() { return getTtsSpeakList; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "g", function() { return getTtsSign; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_polyfill__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_polyfill___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_polyfill__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_config__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_js_libs_utils_cookie__ = __webpack_require__(3);
/**
 * Created by lycheng on 2017/11/23.
 * 产品服务页相关接口
 */




/**
 * 获取用户app
 * @param servicesId
 * @returns {Promise}
 */
function getServiceOpenApps(servicesId, getAppUrl) {
  return new Promise(function (resolve, reject) {
    var url = '/herapi/user/get_app_list_by_service?service_id=' + btoa(servicesId);
    jQuery.ajax({
      url: getAppUrl || url,
      type: 'get',
      dataType: 'json',
      success: function success(data) {
        resolve({
          code: 0,
          data: data
        });
      },
      error: function error() {
        resolve({});
      }
    });
  });
}

/**
 * 获取用户app
 * 代替getServiceOpenApps
 */
function getApps() {
  return new Promise(function (resolve, reject) {
    jQuery.ajax({
      url: '/herapi/product/getAppList',
      type: 'get',
      dataType: 'json',
      cache: false,
      success: function success(result) {
        resolve(result);
      },
      error: function error(s) {
        resolve({});
      }
    });
  });
}

/**
 * 开通服务的接口
 * @param servicesId
 * @param appId
 * @returns {Promise}
 */
function openService(servicesId, appId) {
  return new Promise(function (resolve, reject) {
    jQuery.ajax({
      type: 'get',
      url: __WEBPACK_IMPORTED_MODULE_1_config__["a" /* config */].API + 'mycloud/app/accessService',
      dataType: 'json',
      data: {
        'app_id': appId,
        'service': servicesId
      },
      success: function success(result) {
        resolve({
          code: 0,
          data: result
        });
      },
      error: function error() {
        resolve({});
      }
    });
  });
}

/**
 * 开通ocr服务的接口
 * @param servicesId
 * @param appId
 * @returns {Promise}
 */
function openOcrService(servicesId, appId) {
  return new Promise(function (resolve, reject) {
    var ssoSessionId = __WEBPACK_IMPORTED_MODULE_2_js_libs_utils_cookie__["a" /* cookie */].get('ssoSessionId');
    var accountId = __WEBPACK_IMPORTED_MODULE_2_js_libs_utils_cookie__["a" /* cookie */].get('account_id');
    $.ajax({
      type: 'get',
      url: __WEBPACK_IMPORTED_MODULE_1_config__["a" /* config */].CONSOLE + 'dashboard/app/jsonp/service/add',
      dataType: 'jsonp',
      data: {
        appId: appId,
        services: servicesId,
        ssoSessionId: ssoSessionId,
        account_id: accountId
      },
      jsonp: 'callback',
      jsonpCallback: 'handleResponse',
      success: function success(result) {
        resolve({
          code: 0,
          data: result
        });
      },
      error: function error(result) {
        resolve(result);
      }
    });
  }).catch(function (reason) {
    console.log('catch:', reason);
  });
}

/**
 * 开通新框架服务的接口
 * @param servicesId
 * @param appId
 * @returns {Promise}
 */
function openNewFrameService(servicesId, appId) {
  return new Promise(function (resolve, reject) {
    var ssoSessionId = __WEBPACK_IMPORTED_MODULE_2_js_libs_utils_cookie__["a" /* cookie */].get('ssoSessionId');
    var accountId = __WEBPACK_IMPORTED_MODULE_2_js_libs_utils_cookie__["a" /* cookie */].get('account_id');
    $.ajax({
      type: 'get',
      url: __WEBPACK_IMPORTED_MODULE_1_config__["a" /* config */].CONSOLE + 'dashboard/webapi/jsonp/addService/v1',
      dataType: 'jsonp',
      data: {
        appId: appId,
        services: servicesId,
        ssoSessionId: ssoSessionId,
        account_id: accountId
      },
      jsonp: 'callback',
      jsonpCallback: 'handleResponse',
      success: function success(result) {
        resolve({
          code: 0,
          data: result
        });
      },
      error: function error(result) {
        resolve(result);
      }
    });
  }).catch(function (reason) {
    console.log('catch:', reason);
  });
}

/**
 * 语音合成的接口
 * @param params：
 * {
 *   vcn: aisxping,
 *   vol: 7,
 *   spd: medium,
 *   textPut: '', // 输入的文本
 * }
 * @returns {Promise}
 */
function webTTS(params) {
  return new Promise(function (resolve, reject) {
    jQuery.ajax({
      type: 'post',
      url: '/herapi/solution/synthesis',
      dataType: 'json',
      data: params,
      success: function success(result) {
        resolve(result);
      },
      error: function error() {
        resolve({});
      }
    });
  });
}

function mtranslate(params) {
  // {
  //   fromLang: trans.data.source,
  //     toLang: trans.data.dist,
  //   originText: text
  // }
  return new Promise(function (resolve, reject) {
    $.ajax({
      url: '/herapi/product/translate',
      type: 'post',
      data: params,
      success: function success(result) {
        // result.code = result.flag ? 0 : -1
        resolve(result);
      },
      error: function error() {
        resolve({});
      }
    });
  });
}

/**
 * 获取开放统计的sdkList
 * @returns {Promise}
 */
function getMobileappSdkList() {
  return new Promise(function (resolve, reject) {
    $.ajax({
      url: '/herapi/product/getSdkList',
      success: function success(result) {
        resolve(result);
      },
      error: function error() {
        resolve({});
      }
    });
  });
}

/**
 * 词法分析接口
 * @returns {Promise}
 */
function lexicalAnalysist(params) {
  return new Promise(function (resolve, reject) {
    $.ajax({
      url: '/herapi/index/webltp',
      type: 'POST',
      dataType: 'json',
      data: params,
      success: function success(result) {
        resolve(result);
      },
      error: function error() {
        resolve({});
      }
    });
  });
}

/**
 * 机器翻译niutrans体验接口
 * @returns {Promise}
 */
function getOtsResult(params) {
  return new Promise(function (resolve, reject) {
    $.ajax({
      url: '/herapi/product/ots',
      type: 'POST',
      dataType: 'json',
      data: params,
      success: function success(result) {
        resolve(result);
      },
      error: function error() {
        resolve({});
      }
    });
  });
}

/**
 * 机器翻译体验接口
 * @returns {Promise}
 */
function getItsResult(params) {
  return new Promise(function (resolve, reject) {
    $.ajax({
      url: '/herapi/product/its',
      type: 'POST',
      dataType: 'json',
      data: params,
      success: function success(result) {
        resolve(result);
      },
      error: function error() {
        resolve({});
      }
    });
  });
}

/**
 * 关键词提取type传：ke
 * 如果是调用情感分析type传：sa
 * 关键词 && 情感分析接口
 * @returns {Promise}
 */
function productKesa(params) {
  return new Promise(function (resolve, reject) {
    $.ajax({
      url: '/herapi/product/kesa',
      type: 'POST',
      dataType: 'json',
      data: params,
      success: function success(result) {
        resolve(result);
      },
      error: function error() {
        resolve({});
      }
    });
  });
}

/**
 * 获取在线语音合成的音频src
 * @returns {Promise}
 */
function getOnlineAudioSrc(params, challenge, validate, seccode) {
  return new Promise(function (resolve, reject) {
    $.ajax({
      url: '/herapi/solution/synthesis/v2?challenge=' + challenge + '&validate=' + validate + '&seccode=' + seccode,
      type: 'POST',
      dataType: 'json',
      data: JSON.stringify(params),
      contentType: 'application/json; charset=utf-8',
      success: function success(result) {
        resolve(result);
      },
      error: function error() {
        resolve({});
      }
    });
  });
}

function getVoiceAudioSrc(params, challenge, validate, seccode) {
  return new Promise(function (resolve, reject) {
    $.ajax({
      url: '/herapi/solution/dictation/v2?challenge=' + challenge + '&validate=' + validate + '&seccode=' + seccode,
      type: 'POST',
      dataType: 'json',
      data: JSON.stringify(params),
      contentType: 'application/json; charset=utf-8',
      success: function success(result) {
        resolve(result);
      },
      error: function error() {
        resolve({});
      }
    });
  });
}

/**
 * 获取极验数据进行初始化
 * @returns {Promise}
 */
function getValidate() {
  return new Promise(function (resolve, reject) {
    $.ajax({
      url: '/herapi/plug/validate',
      type: 'get',
      cache: false,
      dataType: 'json',
      success: function success(result) {
        resolve(result);
      },
      error: function error() {
        resolve({});
      }
    });
  });
}
/**
 * 获取听写websocket链接
 * @returns {Promise}
 */
function getIatSign(geettestResult) {
  return new Promise(function (resolve, reject) {
    jQuery.ajax({
      url: '/herapi/product/iat_sign',
      type: 'post',
      dataType: 'json',
      cache: false,
      data: {
        challenge: geettestResult.geetest_challenge,
        validate: geettestResult.geetest_validate,
        seccode: geettestResult.geetest_seccode
      },
      success: function success(data) {
        resolve(data);
      },
      error: function error() {
        resolve({});
      }
    });
  });
}

function getIatLanguage() {
  return new Promise(function (resolve, reject) {
    jQuery.ajax({
      url: '/herapi/product/iat_language_list',
      type: 'post',
      dataType: 'json',
      cache: false,
      success: function success(data) {
        resolve(data);
      },
      error: function error() {
        resolve({});
      }
    });
  });
}

/**
 * 获取合成websocket链接
 * @returns {Promise}
 */
function getTtsSign(geettestResult) {
  return new Promise(function (resolve, reject) {
    jQuery.ajax({
      url: '/herapi/product/tts_sign',
      type: 'post',
      dataType: 'json',
      cache: false,
      data: {
        challenge: geettestResult.geetest_challenge,
        validate: geettestResult.geetest_validate,
        seccode: geettestResult.geetest_seccode
      },
      success: function success(data) {
        resolve(data);
      },
      error: function error() {
        resolve({});
      }
    });
  });
}

/**
 * 合成体验发音人参数列表获取接口
 * @param grade 发音人等级（默认是0，0特色发音人，1精品发音人）
 * @returns {Promise}
 */
function getTtsSpeakList(_ref) {
  var _ref$grade = _ref.grade,
      grade = _ref$grade === undefined ? 0 : _ref$grade;

  return new Promise(function (resolve, reject) {
    jQuery.ajax({
      url: '/herapi/product/tts_language_list',
      type: 'post',
      dataType: 'json',
      data: {
        grade: grade
      },
      cache: false,
      success: function success(data) {
        resolve(data);
      },
      error: function error() {
        resolve({});
      }
    });
  });
}



/***/ }),

/***/ 23:
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(module) {var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

/* eslint-disable */
/* initGeetest 1.0.0
 * 用于加载id对应的验证码库，并支持宕机模式
 * 暴露 initGeetest 进行验证码的初始化
 * 一般不需要用户进行修改
 */
(function (global, factory) {
  'use strict';

  if (( false ? 'undefined' : _typeof(module)) === 'object' && _typeof(module.exports) === 'object') {
    // CommonJS
    module.exports = global.document ? factory(global, true) : function (w) {
      if (!w.document) {
        throw new Error('Geetest requires a window with a document');
      }
      return factory(w);
    };
  } else {
    factory(global);
  }
})(typeof window !== 'undefined' ? window : this, function (window, noGlobal) {
  'use strict';

  if (typeof window === 'undefined') {
    throw new Error('Geetest requires browser environment');
  }
  var document = window.document;
  var Math = window.Math;
  var head = document.getElementsByTagName('head')[0];

  function _Object(obj) {
    this._obj = obj;
  }

  _Object.prototype = {
    _each: function _each(process) {
      var _obj = this._obj;
      for (var k in _obj) {
        if (_obj.hasOwnProperty(k)) {
          process(k, _obj[k]);
        }
      }
      return this;
    }
  };
  function Config(config) {
    var self = this;
    new _Object(config)._each(function (key, value) {
      self[key] = value;
    });
  }

  Config.prototype = {
    api_server: 'api.geetest.com',
    protocol: 'http://',
    type_path: '/gettype.php',
    fallback_config: {
      slide: {
        static_servers: ['static.geetest.com', 'dn-staticdown.qbox.me'],
        type: 'slide',
        slide: '/static/js/geetest.0.0.0.js'
      },
      fullpage: {
        static_servers: ['static.geetest.com', 'dn-staticdown.qbox.me'],
        type: 'fullpage',
        fullpage: '/static/js/fullpage.0.0.0.js'
      }
    },
    _get_fallback_config: function _get_fallback_config() {
      var self = this;
      if (isString(self.type)) {
        return self.fallback_config[self.type];
      } else if (self.new_captcha) {
        return self.fallback_config.fullpage;
      } else {
        return self.fallback_config.slide;
      }
    },
    _extend: function _extend(obj) {
      var self = this;
      new _Object(obj)._each(function (key, value) {
        self[key] = value;
      });
    }
  };
  var isNumber = function isNumber(value) {
    return typeof value === 'number';
  };
  var isString = function isString(value) {
    return typeof value === 'string';
  };
  var isBoolean = function isBoolean(value) {
    return typeof value === 'boolean';
  };
  var isObject = function isObject(value) {
    return (typeof value === 'undefined' ? 'undefined' : _typeof(value)) === 'object' && value !== null;
  };
  var isFunction = function isFunction(value) {
    return typeof value === 'function';
  };
  var callbacks = {};
  var status = {};
  var random = function random() {
    return parseInt(Math.random() * 10000) + new Date().valueOf();
  };
  var loadScript = function loadScript(url, cb) {
    var script = document.createElement('script');
    script.charset = 'UTF-8';
    script.async = true;
    script.onerror = function () {
      cb(true);
    };
    var loaded = false;
    script.onload = script.onreadystatechange = function () {
      if (!loaded && (!script.readyState || script.readyState === 'loaded' || script.readyState === 'complete')) {
        loaded = true;
        setTimeout(function () {
          cb(false);
        }, 0);
      }
    };
    script.src = url;
    head.appendChild(script);
  };
  var normalizeDomain = function normalizeDomain(domain) {
    return domain.replace(/^https?:\/\/|\/$/g, '');
  };
  var normalizePath = function normalizePath(path) {
    path = path.replace(/\/+/g, '/');
    if (path.indexOf('/') !== 0) {
      path = '/' + path;
    }
    return path;
  };
  var normalizeQuery = function normalizeQuery(query) {
    if (!query) {
      return '';
    }
    var q = '?';
    new _Object(query)._each(function (key, value) {
      if (isString(value) || isNumber(value) || isBoolean(value)) {
        q = q + encodeURIComponent(key) + '=' + encodeURIComponent(value) + '&';
      }
    });
    if (q === '?') {
      q = '';
    }
    return q.replace(/&$/, '');
  };
  var makeURL = function makeURL(protocol, domain, path, query) {
    domain = normalizeDomain(domain);

    var url = normalizePath(path) + normalizeQuery(query);
    if (domain) {
      url = protocol + domain + url;
    }

    return url;
  };
  var load = function load(protocol, domains, path, query, cb) {
    var tryRequest = function tryRequest(at) {
      var url = makeURL(protocol, domains[at], path, query);
      loadScript(url, function (err) {
        if (err) {
          if (at >= domains.length - 1) {
            cb(true);
          } else {
            tryRequest(at + 1);
          }
        } else {
          cb(false);
        }
      });
    };
    tryRequest(0);
  };
  var jsonp = function jsonp(domains, path, config, callback) {
    if (isObject(config.getLib)) {
      config._extend(config.getLib);
      callback(config);
      return;
    }
    if (config.offline) {
      callback(config._get_fallback_config());
      return;
    }
    var cb = 'geetest_' + random();
    window[cb] = function (data) {
      if (data.status === 'success') {
        callback(data.data);
      } else if (!data.status) {
        callback(data);
      } else {
        callback(config._get_fallback_config());
      }
      window[cb] = undefined;
      try {
        delete window[cb];
      } catch (e) {}
    };
    load(config.protocol, domains, path, {
      gt: config.gt,
      callback: cb
    }, function (err) {
      if (err) {
        callback(config._get_fallback_config());
      }
    });
  };
  var throwError = function throwError(errorType, config) {
    var errors = {
      networkError: '网络错误'
    };
    if (typeof config.onError === 'function') {
      config.onError(errors[errorType]);
    } else {
      throw new Error(errors[errorType]);
    }
  };
  var detect = function detect() {
    return !!window.Geetest;
  };
  if (detect()) {
    status.slide = 'loaded';
  }
  var initGeetest = function initGeetest(userConfig, callback) {
    var config = new Config(userConfig);
    if (userConfig.https) {
      config.protocol = 'https://';
    } else if (!userConfig.protocol) {
      config.protocol = window.location.protocol + '//';
    }
    jsonp([config.api_server || config.apiserver], config.type_path, config, function (newConfig) {
      var type = newConfig.type;
      var init = function init() {
        config._extend(newConfig);
        callback(new window.Geetest(config));
      };
      callbacks[type] = callbacks[type] || [];
      var s = status[type] || 'init';
      if (s === 'init') {
        status[type] = 'loading';
        callbacks[type].push(init);
        load(config.protocol, newConfig.static_servers || newConfig.domains, newConfig[type] || newConfig.path, null, function (err) {
          if (err) {
            status[type] = 'fail';
            throwError('networkError', config);
          } else {
            status[type] = 'loaded';
            var cbs = callbacks[type];
            for (var i = 0, len = cbs.length; i < len; i = i + 1) {
              var cb = cbs[i];
              if (isFunction(cb)) {
                cb();
              }
            }
            callbacks[type] = [];
          }
        });
      } else if (s === 'loaded') {
        init();
      } else if (s === 'fail') {
        throwError('networkError', config);
      } else if (s === 'loading') {
        callbacks[type].push(init);
      }
    });
  };
  window.initGeetest = initGeetest;
  return initGeetest;
});
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(31)(module)))

/***/ }),

/***/ 449:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_scss_services_lexicalAnalysis_scss__ = __webpack_require__(450);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_scss_services_lexicalAnalysis_scss___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_scss_services_lexicalAnalysis_scss__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_polyfill__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_polyfill___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_polyfill__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_js_libs_utils_services__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_config__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_js_api_services__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_js_libs_gt__ = __webpack_require__(23);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_js_libs_gt___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_js_libs_gt__);








var demoTextList = ['讯飞开放平台作为开放的智能交互技术服务平台，致力于为开发者打造一站式智能人机交互解决方案。', '人工智能是一门极富挑战性的科学，从事这项工作的人必须懂得计算机知识，心理学和哲学。', 'AI大学是由讯飞开放平台打造的人工智能专业学习、交流和培训的AI学习平台。作为国内AI在线学习平台，旨在为 AI 领域开发者、爱好者提供丰富的资源、专业的课程以及共享的服务。'];
var n = 0;

var mnData = [{ "data": { "pos": [{ "code": "b", "name": "状态词" }, { "code": "wp", "name": "标点" }, { "code": "v", "name": "动词" }, { "code": "n", "name": "名词" }, { "code": "m", "name": "数词" }, { "code": "q", "name": "量词" }, { "code": "p", "name": "介词" }, { "code": "u", "name": "助词" }], "nameEntity": [], "word": [{ "text": "讯飞", "type": "n" }, { "text": "开放", "type": "v" }, { "text": "平台", "type": "n" }, { "text": "作为", "type": "v" }, { "text": "业内", "type": "n" }, { "text": "一", "type": "m" }, { "text": "个", "type": "q" }, { "text": "开放", "type": "v" }, { "text": "的", "type": "u" }, { "text": "智能", "type": "n" }, { "text": "交互", "type": "b" }, { "text": "技术", "type": "n" }, { "text": "服务", "type": "v" }, { "text": "平台", "type": "n" }, { "text": "，", "type": "wp" }, { "text": "致力", "type": "v" }, { "text": "于", "type": "p" }, { "text": "为", "type": "p" }, { "text": "开发者", "type": "n" }, { "text": "打造", "type": "v" }, { "text": "一站式", "type": "n" }, { "text": "智能", "type": "n" }, { "text": "人机", "type": "n" }, { "text": "交互", "type": "v" }, { "text": "解决", "type": "v" }, { "text": "方案", "type": "n" }, { "text": "。", "type": "wp" }] } }, { "data": { "pos": [{ "code": "wp", "name": "标点" }, { "code": "v", "name": "动词" }, { "code": "c", "name": "连词" }, { "code": "n", "name": "名词" }, { "code": "d", "name": "副词" }, { "code": "m", "name": "数词" }, { "code": "r", "name": "代词" }, { "code": "q", "name": "量词" }, { "code": "u", "name": "助词" }], "nameEntity": [], "word": [{ "text": "人工智能", "type": "n" }, { "text": "是", "type": "v" }, { "text": "一", "type": "m" }, { "text": "门", "type": "q" }, { "text": "极", "type": "d" }, { "text": "富", "type": "v" }, { "text": "挑战性", "type": "n" }, { "text": "的", "type": "u" }, { "text": "科学", "type": "n" }, { "text": "，", "type": "wp" }, { "text": "从事", "type": "v" }, { "text": "这", "type": "r" }, { "text": "项", "type": "q" }, { "text": "工作", "type": "v" }, { "text": "的", "type": "u" }, { "text": "人", "type": "n" }, { "text": "必须", "type": "d" }, { "text": "懂得", "type": "v" }, { "text": "计算机", "type": "n" }, { "text": "知识", "type": "n" }, { "text": "，", "type": "wp" }, { "text": "心理学", "type": "n" }, { "text": "和", "type": "c" }, { "text": "哲学", "type": "n" }, { "text": "。", "type": "wp" }] } }, { "data": { "pos": [{ "code": "ws", "name": "外来词" }, { "code": "wp", "name": "标点" }, { "code": "v", "name": "动词" }, { "code": "c", "name": "连词" }, { "code": "nl", "name": "处所词" }, { "code": "n", "name": "名词" }, { "code": "m", "name": "数词" }, { "code": "a", "name": "形容词" }, { "code": "p", "name": "介词" }, { "code": "q", "name": "量词" }, { "code": "u", "name": "助词" }], "nameEntity": [{ "valueList": ["AI", "大学"], "typeName": "机构名" }], "word": [{ "text": "AI", "type": "ws" }, { "text": "大学", "type": "n" }, { "text": "是", "type": "v" }, { "text": "由", "type": "p" }, { "text": "讯", "type": "n" }, { "text": "飞", "type": "v" }, { "text": "开放", "type": "v" }, { "text": "平台", "type": "n" }, { "text": "打造", "type": "v" }, { "text": "的", "type": "u" }, { "text": "人工智能", "type": "n" }, { "text": "专业", "type": "n" }, { "text": "学习", "type": "v" }, { "text": "、", "type": "wp" }, { "text": "交流", "type": "v" }, { "text": "和", "type": "c" }, { "text": "培训", "type": "v" }, { "text": "的", "type": "u" }, { "text": "AI", "type": "ws" }, { "text": "学习", "type": "v" }, { "text": "平台", "type": "n" }, { "text": "。", "type": "wp" }, { "text": "作为", "type": "v" }, { "text": "国内", "type": "nl" }, { "text": "首", "type": "m" }, { "text": "个", "type": "q" }, { "text": "AI", "type": "ws" }, { "text": "在线", "type": "n" }, { "text": "学习", "type": "v" }, { "text": "平台", "type": "n" }, { "text": "，", "type": "wp" }, { "text": "旨在", "type": "v" }, { "text": "为", "type": "p" }, { "text": "AI", "type": "ws" }, { "text": "领域", "type": "n" }, { "text": "开发者", "type": "n" }, { "text": "、", "type": "wp" }, { "text": "爱好者", "type": "n" }, { "text": "提供", "type": "v" }, { "text": "丰富", "type": "a" }, { "text": "的", "type": "u" }, { "text": "资源", "type": "n" }, { "text": "、", "type": "wp" }, { "text": "专业", "type": "n" }, { "text": "的", "type": "u" }, { "text": "课程", "type": "n" }, { "text": "以及", "type": "c" }, { "text": "共享", "type": "v" }, { "text": "的", "type": "u" }, { "text": "服务", "type": "v" }, { "text": "。", "type": "wp" }] } }];

var functionalExperienceModel = {
  result: {},
  // 增加极验
  geetestApi1: function geetestApi1() {
    var that = this;
    var config = this.config;
    $.ajax({
      url: '/herapi/plug/validate?t=' + new Date().getTime(),
      type: 'get',
      dataType: 'json',
      success: function success(data) {
        // 调用 initGeetest 进行初始化
        // 参数1：配置参数
        // 参数2：回调，回调的第一个参数验证码对象，之后可以使用它调用相应的接口
        initGeetest({
          // 以下 4 个配置参数为必须，不能缺少
          gt: data.data.gt,
          challenge: data.data.challenge,
          offline: !data.data.success, // 表示用户后台检测极验服务器是否宕机
          new_captcha: data.data.new_captcha, // 用于宕机时表示是新验证码的宕机
          product: 'bind', // 产品形式，包括：float，popup
          width: '300px'
          // 更多配置参数说明请参见：http://docs.geetest.com/install/client/web-front/
        }, function (captchaObj) {
          captchaObj.onReady(function () {}).onSuccess(function () {
            that.result = captchaObj.getValidate();
            if (!that.result) {
              return alert('请完成验证');
            }
            that.analysis();
          });
          // 开始分析
          $('#startLoad').on('click', function () {
            if (that.checkTextarea()) {
              captchaObj.verify();
            }
          });
        });
      }
    });
  },
  analysis: function analysis(isDemo) {
    var that = this;

    if (isDemo) {
      that.render(mnData[n].data);
    } else {
      if (that.checkTextarea()) {
        var params = {
          challenge: that.result.geetest_challenge,
          validate: that.result.geetest_validate,
          seccode: that.result.geetest_seccode,
          text: that.checkTextarea()
        };
        $.mask();
        Object(__WEBPACK_IMPORTED_MODULE_4_js_api_services__["j" /* lexicalAnalysist */])(params).then(function (result) {
          $.mask('hide');
          if (result.flag && result.data) {
            that.render(result.data);
          } else if (result.code === '99999' || result.code === 99999) {
            $.alerts.alert('系统异常，请稍后再试');
          } else if (result.code === '20011' || result.code === 20011) {
            $.alerts.alert('验证码校验不通过');
          }
        });
      }
    }
  },
  render: function render(res) {
    var that = this;

    that.renderParticipleAndPart(res.word, res.pos);
    that.renderNamedEntity(res.nameEntity);
  },
  // 渲染分词&词性标注
  renderParticipleAndPart: function renderParticipleAndPart(res, type) {
    var participleTmpl = '';
    var partOfSpeechTmpl = '';

    for (var i = 0, len = res.length; i < len; i++) {
      participleTmpl += '<li class="type-' + res[i].type + '" data-code="type-' + res[i].type + '">' + res[i].text + '</li>';
    }
    for (var j = 0, num = type.length; j < num; j++) {
      partOfSpeechTmpl += '<li class="type-' + type[j].code + '" data-code="type-' + type[j].code + '">' + type[j].name + '</li>';
    }
    $('#participle').empty().html(participleTmpl);
    $('#partOfSpeech').empty().html(partOfSpeechTmpl);
    // 触发第一个分词选中
    setTimeout(function () {
      $('#participle li:first-child').trigger('click');
    }, 50);
  },
  // 渲染命名实体识别结果
  renderNamedEntity: function renderNamedEntity(res) {
    var tmpl = '';
    var itemsTmpl = '';

    $('#namedEntityWrap').empty();
    if (res && res.length > 0) {
      for (var i = 0, len = res.length; i < len; i++) {
        itemsTmpl = '';
        for (var j = 0, num = res[i].valueList.length; j < num; j++) {
          itemsTmpl += '<li>' + res[i].valueList[j] + '</li>';
        }
        tmpl += '<div class="type-item">\n          <div class="type-name select">' + res[i].typeName + '</div>\n          <ul>' + itemsTmpl + '</ul>\n        </div>';
      }
      $('#namedEntityWrap').html(tmpl);
    }
  },
  // 切换示例文本
  changeDemo: function changeDemo() {
    if (n >= demoTextList.length - 1) {
      n = 0;
    } else {
      n += 1;
    }
    $('#analysisText').val(demoTextList[n]);
    this.analysis(true);
  },
  // 检查文本框输入内容
  checkTextarea: function checkTextarea() {
    var text = $('#analysisText').val().trim();
    var rules = new RegExp(/^[a-zA-Z\d]+$/);

    if (text === '') {
      $.alerts.alert('您没有输入内容');
      return false;
    } else if (text.length > 100) {
      $.alerts.alert('最多输入100字');
      return false;
    } else if (rules.test(text.replace(/\s/g, ''))) {
      $.alerts.alert('抱歉，仅支持中文内容分析');
      return false;
    } else {
      return String(text);
    }
  },
  addEvent: function addEvent() {
    var that = this;
    // 更换示例
    $(document).on('click', '#changText', function () {
      that.changeDemo();
    });
    // 分词&词性点击效果
    $(document).on('click', '#participleAndPart li', function (e) {
      var $this = $(e.currentTarget);
      var $parent = $this.parent();
      var $parentSiblingsUl = $parent.siblings('ul');
      var code = $this.data('code');
      if (!$this.hasClass('select')) {
        $this.parent().find('li').removeClass('select');
        $this.addClass('select');
        $parentSiblingsUl.find('li').removeClass('select');
        $parentSiblingsUl.find('.' + code).addClass('select');
      }
    });
  },
  init: function init() {
    var that = this;

    $('#analysisText').val(demoTextList[n]);
    that.analysis(true);
    that.geetestApi1();
    that.addEvent();
  }
};

$(function () {
  Object(__WEBPACK_IMPORTED_MODULE_2_js_libs_utils_services__["b" /* serviceTopbar */])();
  functionalExperienceModel.init();
});

/***/ }),

/***/ 450:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 5:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXTERNAL MODULE: ./src/js/api/user.js
var user = __webpack_require__(4);

// EXTERNAL MODULE: ./src/js/libs/utils-layer.js
var utils_layer = __webpack_require__(7);

// EXTERNAL MODULE: ./src/js/libs/utils-cookie.js
var utils_cookie = __webpack_require__(3);

// EXTERNAL MODULE: ./src/js/libs/utils.js
var utils = __webpack_require__(1);

// EXTERNAL MODULE: ./src/js/config/prod.js
var prod = __webpack_require__(0);

// EXTERNAL MODULE: ./src/scss/component/announcement.scss
var announcement = __webpack_require__(6);
var announcement_default = /*#__PURE__*/__webpack_require__.n(announcement);

// CONCATENATED MODULE: ./src/js/libs/utils-announcement.js
/**
 * 公告
 */


var _countDown = null;
var ancmtModel = {
  addEvent: function addEvent() {
    $('.ancmt-detail').on('click', '.ancmt-bullet-box-close-btn', function () {
      $('.ancmt-wrap').hide();
    });
    $('body').not('.ancmt-wrap').bind('click', function () {
      $('.ancmt-wrap').hide();
    });
  },
  countDown: function countDown() {
    var allTime = 15;
    _countDown = setInterval(function () {
      $('#abb_num').text(--allTime);
      if (allTime < 0) {
        $('.ancmt-wrap').hide();
        clearInterval(_countDown);
      }
    }, 1000);
  },
  fireAction: function fireAction() {
    $('#open_announcement').bind('click', function (e) {
      e.stopPropagation();
      $('.ancmt-wrap').show();
    });
  },
  showTop: function showTop() {
    if (!utils_cookie["a" /* cookie */].get('top_banner_closed')) {
      $('#top_banner_wrap').show();
    }
  },
  bindTopAction: function bindTopAction() {
    $('#close_banner_top').bind('click', function () {
      $('#top_banner_wrap').hide();
      var curDate = new Date();
      var curTamp = curDate.getTime();
      var curWeeHours = new Date(curDate.toLocaleDateString()).getTime() - 1;
      var passedTamp = curTamp - curWeeHours;
      var leftTamp = 24 * 60 * 60 * 1000 - passedTamp;
      var leftTime = new Date();
      leftTime.setTime(leftTamp + curTamp);
      utils_cookie["a" /* cookie */].pureSet('top_banner_closed', true, leftTime.toGMTString() + ';path=/');
    });
  },
  init: function init() {
    var that = this;
    that.addEvent();
    that.fireAction();
    that.showTop();
    that.bindTopAction();
    // that.countDown()
  }
};
ancmtModel.init();
// CONCATENATED MODULE: ./src/js/libs/utils-suspension.js
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return suspension; });
/**
 * Created by lycheng on 2017/11/29.
 * 悬浮的狗，返回顶部
 */







function initZcScript(w, d, e, x) {
  w[e] = function () {
    w.cbk = w.cbk || [];
    w.cbk.push(arguments);
  };
  x = d.createElement("script");
  x.async = true;
  x.id = "zhichiScript";
  x.className = "im-btn";
  x.src = "https://chat.sobot.com/chat/frame/v2/entrance.js?sysnum=1f851a5acb6e4f408a3e3e5487750951";
  d.body.appendChild(x);
}

function initZc(userInfo) {
  var nick = userInfo.nickname;
  var nickLogin = userInfo.login;
  var nickMiddle = nickLogin.length / 2;
  var isEven = nickLogin.length % 2 === 0;
  var nickEncry = isEven ? nickMiddle : Math.ceil(nickMiddle) - 2;
  nickLogin = nickLogin.length > 5 ? nickLogin.replace(nickLogin.substring(nickEncry, nickEncry + 2), "***") : nickLogin;
  user["a" /* aesEncry */](userInfo.uid).then(function (r) {
    var uid = r.data;
    var isZcBack = window.location.search.includes("isZc=1");
    initZcScript(window, document, "zc");
    var args = {
      customField7: uid
    };
    var prms = {
      uid: uid
    };
    zc("config", {
      uname: nick || nickLogin,
      custom: true, // 设置自定义
      color: "2277e6",
      customer_fields: JSON.stringify(args),
      params: JSON.stringify(prms),
      partnerid: uid,
      auto_expand: isZcBack
    });
    zc("dynamic_ready");
  });
}
/**
 * 右侧悬浮
 * @param s:距离顶部的高度
 */
function suspension(s, isIndex) {
  var $suspension = $('.suspension');
  if (!$suspension.length) {
    return;
  }
  var show400 = !(Object(utils["d" /* isWorkTime */])() && Object(utils["e" /* isWorkday */])());
  if (show400) {
    $('#feedback_btn').before('\n    <div class="suspension-item-wrap suspension-phone-wrap">\n      <i class="icons icons-suspension-phone"></i>\n      <div>\n        <div class="suspension-number-title">\u670D\u52A1\u70ED\u7EBF</div>\n        <p class="suspension-number-phone">4000-199-199</p>\n      </div>\n    </div>\n    ');
  }
  var $backTop = $('.suspension-back-top');
  var $susIcon = $('.sus-icon');
  var winH = $(window).height();
  $(window).scroll(function () {
    var scrollTop = $(window).scrollTop();
    if (scrollTop < s - winH / 2) {
      $suspension.css({
        position: 'absolute',
        top: s + 'px'
      });
    } else {
      $suspension.css({
        position: 'fixed',
        top: '50%'
      });
    }
    if (scrollTop > winH / 2) {
      $backTop.show();
    } else {
      $backTop.hide();
    }
  });
  $(window).scroll();
  $backTop.click(function () {
    $('body, html').animate({ 'scrollTop': 0 }, 500);
    return false;
  });

  function checkImLog() {
    user["d" /* getUserinfo */]().then(function (result) {
      if (result.code === 80000) {
        $(".im-icon").removeClass("im-btn");
        $(".im-icon").click(function () {
          var jumpBack = typeof window !== "undefined" ? Base64.encode(Object(utils["f" /* setQueryString */])("isZc", 1)) : "";
          window.location.href = prod["a" /* config */].PASSPORT + '/login?jump=' + jumpBack;
        });
      } else {
        initZc(result.data);
      }
    });
  }

  checkImLog();

  // $(".im-icon").click(function () {
  //   checkImLog()
  // });
}


/***/ }),

/***/ 6:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ })

},[449]);


// WEBPACK FOOTER //
// js/services/lexicalAnalysis.d35a75a684a23f5d0b3b.bundle.js